import { ConnectorStatus, ConnectorStatusType } from '../types/connector'

type ConnectorStatusTagProps = {
  status: ConnectorStatusType
}

const statusText: Record<ConnectorStatusType, string> = {
  [ConnectorStatus.ONLINE]: 'Online',
  [ConnectorStatus.DISCONNECTED]: 'Disconnected',
}

const baseStyles = 'w-fit inline rounded-lg py-1 px-3 text-center text-sm font-medium'

const statusClasses: Record<ConnectorStatusType, string> = {
  [ConnectorStatus.ONLINE]: 'text-green-700 dark:text-green-400 bg-green-100 dark:bg-green-900/30',
  [ConnectorStatus.DISCONNECTED]: 'text-red-700 dark:text-red-400 bg-red-100 dark:bg-red-900/30',
}

const ConnectorStatusTag = ({ status }: ConnectorStatusTagProps) => {
  return (
    <span className={`${baseStyles} ${statusClasses[status]}`}>
      {statusText[status]}
    </span>
  )
}

export default ConnectorStatusTag
